import IDisplayContainer from "../interfaces/IDisplayContainer";
import DisplayContainer from "./DisplayContainer";

export default class ActivityContainer extends DisplayContainer implements IDisplayContainer {
    protected completeFunction: Function;
    protected endEarly: boolean = false;
    constructor(completeFunction: Function) {
        super();
        this.completeFunction = completeFunction;
    }

    protected activityComplete(): void {
        this.completeFunction(this.endEarly);
    }
}